import { render } from "./LoginLayout.vue?vue&type=template&id=6adfd385&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./login-layout.scss?vue&type=style&index=0&id=6adfd385&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adfd385"]])

export default __exports__